export default __webpack_public_path__ + "static/media/video-back-shape-icon.7e0bdb69.svg";